import styled from 'styled-components'

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 64px 16px 0;
`

export const ModalTitle = styled.span`
  font-family: 'Segoe UI';
  font-weight: 600;
  font-size: 20px;
  line-height: 150%;
  color: ${({ theme }) => theme.color.darkGrey};
`

export const CountryCell = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const Flag = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  border-radius: 2px;
  overflow: hidden;

  img {
    display: block;
  }
`

export const CountryName = styled.span`
  font-weight: 600;
  font-size: 12px;
  line-height: 150%;
  text-align: left;
  color: ${({ theme }) => theme.color.darkGrey};
`
